import EventsLeaderboard from './EventsLeaderboard';

export default EventsLeaderboard;
